export const Add = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 23.22C6.07 23.22 1.25 18.4 1.25 12.47C1.25 6.53997 6.07 1.71997 12 1.71997C17.93 1.71997 22.75 6.53997 22.75 12.47C22.75 18.4 17.93 23.22 12 23.22ZM12 3.21997C6.9 3.21997 2.75 7.36997 2.75 12.47C2.75 17.57 6.9 21.72 12 21.72C17.1 21.72 21.25 17.57 21.25 12.47C21.25 7.36997 17.1 3.21997 12 3.21997Z" />
    <path d="M16 13.22H8C7.59 13.22 7.25 12.88 7.25 12.47C7.25 12.06 7.59 11.72 8 11.72H16C16.41 11.72 16.75 12.06 16.75 12.47C16.75 12.88 16.41 13.22 16 13.22Z" />
    <path d="M12 17.22C11.59 17.22 11.25 16.88 11.25 16.47V8.46997C11.25 8.05997 11.59 7.71997 12 7.71997C12.41 7.71997 12.75 8.05997 12.75 8.46997V16.47C12.75 16.88 12.41 17.22 12 17.22Z" />
  </svg>
);
